import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import useIsNewCarFilterApplied from '~/hooks/srp/selectors/useIsNewCarFilterApplied';

export default function useLogHasNewVehicleFilter() {
  const hasNewCarFilter = useIsNewCarFilterApplied();

  useEffect(() => {
    if (hasNewCarFilter) {
      datadogRum.addAction('new-car-filter-applied', { hasNewCarFilter });
    }
  }, [hasNewCarFilter]);

  return null;
}
